// Assignee picker submenu for the task row context menu.
import { Menu, MenuItem, ListItemText } from '@mui/material';
import { useT } from '@/i18n/useT';

/**
 * @param {{
 *   task: import('@/types').Task,
 *   open: boolean,
 *   anchorPosition: { mouseX: number, mouseY: number }|null,
 *   personOptions: string[],
 *   onClose: () => void,
 *   onAssignPerson: (person: string|null) => void,
 * }} props
 */
export function TaskContextMenuAssign({
  task,
  open,
  anchorPosition,
  personOptions,
  onClose,
  onAssignPerson,
}) {
  const t = useT();

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={
        anchorPosition
          ? { top: anchorPosition.mouseY, left: anchorPosition.mouseX + 4 }
          : undefined
      }
      slotProps={{ list: { 'data-testid': 'task-context-menu-assign' } }}
    >
      {task.person ? (
        <MenuItem
          onClick={() => onAssignPerson(null)}
          data-testid="context-menu-clear-assignee"
        >
          <ListItemText
            primary={t('contextMenu.clearAssignee', 'No longer waiting')}
          />
        </MenuItem>
      ) : null}
      {personOptions.map((person) => (
        <MenuItem
          key={person}
          onClick={() => onAssignPerson(person)}
          data-testid={`context-menu-assign-${person}`}
        >
          <ListItemText primary={person} />
        </MenuItem>
      ))}
    </Menu>
  );
}
